/**
 * Canonical FAQ list — sourced ONCE so the /faq page, the homepage FAQ section
 * and the JSON-LD FAQPage schema stay in sync.
 */
export const FAQ_ITEMS = [
  {
    q: "What is PixelEmpire?",
    a: "PixelEmpire AI is a 100×100 permanent digital advertising grid — 10,000 blocks total. Businesses claim a block, upload a logo, and their ad stays live on the site forever with a do-follow SEO backlink pointing at their website.",
  },
  {
    q: "How much does one block cost?",
    a: "$0.50 per pixel. A single 10×10 block contains 100 pixels, so one block is $50. Larger clusters scale linearly: a 20×20 block is $200, a 30×30 is $450, and so on. The first 50 blocks of the launch are 100% free — no card required.",
  },
  {
    q: "Is my advertisement permanent?",
    a: "Yes. Every purchase is a one-time payment for lifetime placement. There are no monthly renewals, no auto-charges, and no expiration date. Your block stays live for as long as the pixel-empires.com platform is live.",
  },
  {
    q: "Can I edit my advertisement?",
    a: "Yes — log in to your dashboard any time to swap the logo, update the destination URL, edit the description, or change the category. Grid position is fixed at time of claim but everything else can be edited.",
  },
  {
    q: "Who can advertise?",
    a: "Anyone with a website. Startups, creators, agencies, local businesses, ecommerce brands, portfolio owners, non-profits — no vertical restrictions except for illegal content, adult content, malware, and other clearly-unsafe categories.",
  },
  {
    q: "How do I buy blocks?",
    a: "Open the homepage, drag-select any empty area on the grid, upload your logo and details, and check out via Stripe. Cards, Apple Pay, Google Pay, and international payment methods are all supported. Your ad publishes within seconds of the payment clearing.",
  },
  {
    q: "Why are only 10,000 blocks available?",
    a: "Scarcity is the entire point. The Million Dollar Homepage worked in 2005 because there were exactly 1,000,000 pixels — no more, no less. PixelEmpire honors that formula: 100×100 grid, 10,000 blocks, and once they're gone, no new inventory will ever be added.",
  },
  {
    q: "Do I get an SEO backlink?",
    a: "Yes. Every paid block automatically appears on our public /directory page with a real do-follow anchor tag pointing at your destination URL. This passes real page-authority to your site, unlike most ad networks which use nofollow or redirect links.",
  },
  {
    q: "What happens if PixelEmpire shuts down?",
    a: "We'd give owners at least 12 months notice and, if possible, hand over the raw grid data. Realistically the site is designed to run for decades on a fixed running cost.",
  },
  {
    q: "Do you offer refunds?",
    a: "Yes — full refund within 30 days of claim if you haven't been featured or received measurable traffic. After 30 days, refunds are considered case-by-case (usually only for platform errors).",
  },
];
